import { keyframes, styled } from "src/styles/theme";
import * as RadixTooltip from "@radix-ui/react-tooltip";

const slideUpAndFade = keyframes({
  "0%": { opacity: 0, transform: "translateY(4px)" },
  "100%": { opacity: 1, transform: "translateY(0)" },
});

const slideRightAndFade = keyframes({
  "0%": { opacity: 0, transform: "translateX(-4px)" },
  "100%": { opacity: 1, transform: "translateX(0)" },
});

const slideDownAndFade = keyframes({
  "0%": { opacity: 0, transform: "translateY(-4px)" },
  "100%": { opacity: 1, transform: "translateY(0)" },
});

const slideLeftAndFade = keyframes({
  "0%": { opacity: 0, transform: "translateX(4px)" },
  "100%": { opacity: 1, transform: "translateX(0)" },
});

RadixTooltip.Root.defaultProps = {
  delayDuration: 300,
};

export const Tooltip = {
  ...RadixTooltip,

  Content: styled(RadixTooltip.Content, {
    padding: "$2 $3",
    borderRadius: "$2",
    boxShadow: "$2",
    backgroundColor: "$surface",
    color: "$primaryText",
    fontSize: "$sm",

    animationDuration: "$transitions$duration5",
    animationTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
    '&[data-state="delayed-open"]': {
      '&[data-side="top"]': { animationName: slideDownAndFade },
      '&[data-side="right"]': { animationName: slideLeftAndFade },
      '&[data-side="bottom"]': { animationName: slideUpAndFade },
      '&[data-side="left"]': { animationName: slideRightAndFade },
    },
  }),

  AdditionalInfo: styled("div", {
    position: "absolute",
    top: "50%",
    right: "calc(100% + $3)",
    transform: "translateY(-50%)",
    opacity: 0.8,
    color: "$neutralText",
    fontFamily: "$mono",
    fontSize: "$xs",
    fontWeight: "$light",
  }),
};
